export default __webpack_public_path__ + "static/media/ally_grid_xl.297b6f67.jpg";